import { Grid } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import RxTextField from "../../../components/RxTextField";
import api from "../../../config/AxiosConfig";
import { SuccessResponseDTO } from "../../../constants/CommonObject";
import { RegisterObject, RegisterObjectInitialValue } from "../RegisterObject";
import { UserStepFormValidationObject } from "../RegisterPage";
import styles from "./LoginInfoStepStyle.module.css";
import LoginInfoStepValidation from "./LoginInfoStepValidation";

interface LoginInfoStepProps {
	setValidataResult?: any;
	values?: RegisterObject;
}

const LoginInfoStep = (props: LoginInfoStepProps) => {
	const [validationPasswordMessage, setValidationPasswordMessage] =
		useState<string>("");
	const formik = useFormik({
		initialValues: props.values ?? RegisterObjectInitialValue,
		validationSchema: LoginInfoStepValidation,
		validateOnBlur: true,
		validateOnChange: true,
		onSubmit: () => {
			// Form submit edilmediği için bulunuyor. (Sonar uyarısı için)
			console.log("No submit button for this form...");
		},
	});
	useEffect(() => {
		if (!formik.isValid || validationPasswordMessage !== "") {
			props.setValidataResult &&
				props.setValidataResult(
					(
						prev: UserStepFormValidationObject
					): UserStepFormValidationObject => {
						return {
							...prev,
							isLoginInfoStepValid: false,
						};
					}
				);
		} else {
			props.setValidataResult &&
				props.setValidataResult(
					(
						prev: UserStepFormValidationObject
					): UserStepFormValidationObject => {
						return {
							...prev,
							isLoginInfoStepValid: true,
						};
					}
				);
		}
	}, [formik.isValid, validationPasswordMessage]); // eslint-disable-line

	useEffect(() => {
		props.setValidataResult &&
			props.setValidataResult(
				(
					prev: UserStepFormValidationObject
				): UserStepFormValidationObject => {
					return { ...prev, values: formik.values };
				}
			);
	}, [formik.values]); // eslint-disable-line

	useEffect(() => {
		formik.validateForm();
	}, []); // eslint-disable-line

	const checkPasswordValidation = async (passwordString: string) => {
		const result: SuccessResponseDTO = await api.post(
			"/1/users/check-password",
			{
				password: passwordString,
			}
		);
		setValidationPasswordMessage(
			result.responseValue === "Başarılı" ? "" : result.responseValue
		);
	};

	return (
		<form>
			<Grid container direction="row" spacing={3}>
				<Grid item xs={3} sm={3}></Grid>
				<Grid item xs={6} sm={6}>
					<Grid container spacing={1}>
						<Grid item xs={12} sm={12}>
							<RxTextField
								fullwidth
								id="loginInfo.email"
								name="loginInfo.email"
								label="E-Posta Adresiniz"
								placeholder="E-Posta Adresiniz"
								value={formik.values.loginInfo.email}
								onChange={formik.handleChange}
								onBlur={formik.handleBlur}
								required
								error={
									formik.touched.loginInfo?.email &&
									Boolean(formik.errors.loginInfo?.email)
								}
								helperText={
									formik.touched.loginInfo?.email &&
									formik.errors.loginInfo?.email
								}
								helperTextStyle={styles.helperTextStyle}
								inputLabelClassName={styles.inputLabel}
							/>
						</Grid>
						<Grid item xs={12} sm={12}>
							<Grid container spacing={0}>
								<Grid item xs={12} sm={12}>
									<RxTextField
										required
										fullwidth
										type="password"
										id="loginInfo.password"
										name="loginInfo.password"
										label="Parolanız"
										placeholder="Parolanız"
										onBlur={formik.handleBlur}
										onChange={(event: any) => {
											let value = event?.target.value;
											if (value.length === 0) {
												setValidationPasswordMessage("");
											} else {
												checkPasswordValidation(value);
											}
											formik.setFieldValue(
												"loginInfo.password",
												value
											);
										}}
										value={formik.values.loginInfo.password}
										error={
											validationPasswordMessage !== "" ||
											(formik.touched.loginInfo?.password &&
												Boolean(formik.errors.loginInfo?.password))
										}
										helperText={
											formik.touched.loginInfo?.password &&
											formik.errors.loginInfo?.password
										}
										helperTextStyle={styles.helperTextStyle}
										inputLabelClassName={styles.inputLabel}
									/>
								</Grid>
								<Grid item xs={12} sm={12}>
									{validationPasswordMessage && (
										<Grid item xs={12} sm={12}>
											<Alert
												icon={false}
												severity="error"
												className={styles.alertStyle}
											>
												{validationPasswordMessage}
											</Alert>
										</Grid>
									)}
								</Grid>
							</Grid>
						</Grid>
						<Grid item xs={12} sm={12}>
							<RxTextField
								fullwidth
								required
								type="password"
								id="loginInfo.passwordConfirm"
								name="loginInfo.passwordConfirm"
								label="Parolanız (Tekrar)"
								placeholder="Parolanız (Tekrar)"
								onBlur={formik.handleBlur}
								onChange={formik.handleChange}
								value={formik.values.loginInfo.passwordConfirm}
								error={
									formik.touched.loginInfo?.passwordConfirm &&
									Boolean(formik.errors.loginInfo?.passwordConfirm)
								}
								helperText={
									formik.touched.loginInfo?.passwordConfirm &&
									formik.errors.loginInfo?.passwordConfirm
								}
								helperTextStyle={styles.helperTextStyle}
								inputLabelClassName={styles.inputLabel}
							/>
						</Grid>
					</Grid>
				</Grid>
				<Grid item xs={3} sm={3}></Grid>
				<Grid item xs={3} sm={3}></Grid>
				<Grid item xs={6} sm={6}>
					<Grid container spacing={1}>
						<Grid item xs={12} sm={12}>
							<Alert severity="warning">
								E-Posta Adresinizin doğruluğundan emin olunuz.
								Kaydınızın tamamlanabilmesi için aktivasyon mesajı bu
								e-posta adresinize gelecektir.
							</Alert>
						</Grid>
					</Grid>
				</Grid>
				<Grid item xs={3} sm={3}></Grid>
			</Grid>
		</form>
	);
};
export default LoginInfoStep;
